import React, { useContext, useEffect, useState } from "react";
import Button from "../../components/Button/Button";
import Input, { TextArea } from "../../components/Input/Input";
import MaterialIcons from "../../components/MaterialIcons";
import { validRoll } from "../../utils";
import { arrow, blobsTexture, tick } from "../../utils/images";
import GlobalContext from "../../context/GlobalContext";
import "./apply.scss";

const Apply = () => {
	const { axiosInstance, createNewApplication } = useContext(GlobalContext);
	const [applyData, setApplyData] = useState({
		rollNo: "",
		name: "",
		phone: "",
		resume: "",
		purpose: "",
		reviewed: false,
		verified: false,
	});
	const [activeSection, setActiveSection] = useState(1);
	const [otp, setOtp] = useState(Array(6).fill(""));
	const [showOTPBox, setShowOTPBox] = useState(false);
	const [isOtpValid, setIsOtpValid] = useState(false);
	const [isValidInput, setIsValidInput] = useState(false);

	const validate = () => {
		setIsValidInput(() => false);
		switch (activeSection) {
			case 1:
				if (validRoll(applyData.rollNo) && isOtpValid) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 2:
				if (applyData.name.length > 0) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 3:
				if (applyData.phone.length >= 10) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 4:
				if (applyData.resume.length > 0) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			case 5:
				if (applyData.purpose.split(" ").length > 50) {
					setIsValidInput(() => true);
					return true;
				}
				return false;
			default:
				setIsValidInput(() => false);
				break;
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setApplyData((p) => ({ ...p, [name]: value }));
		validate();
	};
	useEffect(() => {
		if (validRoll(applyData.rollNo) && isOtpValid)
			setActiveSection(() => 2);
	}, [applyData.rollNo, isOtpValid]);
	useEffect(() => {
		validate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeSection, isOtpValid]);

	const handlePartialSubmit = (e) => {
		e?.preventDefault();
		let check = validate();
		if (check) setActiveSection((p) => p + 1);
	};

	const handleSubmit = async () => {
		try {
			await createNewApplication(applyData);
			setActiveSection(() => 6);
		} catch (error) {
			alert(error);
		}
	};

	return (
		<main className="apply">
			{activeSection > 1 && activeSection < 6 && (
				<div className="apply-left">
					<button
						className="icon"
						onClick={(e) => {
							e.preventDefault();
							if (activeSection > 1)
								setActiveSection((p) => p - 1);
						}}
						title="Go to Previous Section"
					>
						<MaterialIcons>arrow_back</MaterialIcons>
					</button>
				</div>
			)}
			{activeSection < 5 && isOtpValid && isValidInput && (
				<div className="apply-right">
					<button
						className="icon"
						onClick={(e) => {
							e.preventDefault();
							if (activeSection < 5)
								setActiveSection((p) => p + 1);
						}}
						title="Go to Next Section"
					>
						<MaterialIcons>arrow_forward</MaterialIcons>
					</button>
				</div>
			)}
			{activeSection === 1 && (
				<section
					className="apply-1"
					style={{
						backgroundColor: "var(--green)",
						color: "var(--white)",
					}}
				>
					<div className="apply-head" data-aos="fade-left">
						<h1>
							<ol start="1">
								<li>Enter your email</li>
							</ol>
						</h1>
					</div>
					<div className="apply-body" data-aos="fade-left">
						<form
							onSubmit={async (e) => {
								e.preventDefault();
								if (validRoll(applyData.rollNo)) {
									try {
										await axiosInstance.post(
											"/api/otp/generate",
											{
												rollNo: applyData.rollNo,
												type: "application",
											}
										);
										setShowOTPBox(true);
									} catch (err) {
										console.error(err);
										alert(err?.response?.data?.message);
									}
								} else alert("Fill a vaild Roll No.");
							}}
						>
							<div className="apply-body-top">
								<Input
									name="rollNo"
									value={applyData.rollNo}
									onChange={handleChange}
									placeholder="Roll No."
									disabled={isOtpValid}
								/>
								<Input value="@iiitu.ac.in" disabled={true} />
							</div>
							<div className="apply-body-bottom">
								<Button
									text="Verify your email"
									color="blue"
									type="submit"
									size="small"
								/>
							</div>
						</form>
						{showOTPBox && (
							<form
								className="apply-body-otp"
								style={{
									display: "flex",
									justifyContent: "flex-start",
								}}
								autoComplete="false"
								onSubmit={async (e) => {
									e.preventDefault();
									if (
										otp.every(
											(p) =>
												p.length === 1 &&
												+p >= 0 &&
												+p <= 9
										)
									) {
										try {
											const res =
												await axiosInstance.post(
													"/api/otp/verify",
													{
														rollNo: applyData.rollNo,
														otp: otp.join(""),
														type: "application",
													}
												);
											if (res.status === 200) {
												setActiveSection(() => 2);
												setIsOtpValid(true);
											}
										} catch (err) {
											console.error(err);
											alert(err?.response?.data?.message);
										}
									} else alert("Enter a valid 6 digit OTP");
								}}
							>
								<div className="apply-body-otp__boxes">
									{otp.map((num, id) => (
										<Input
											name={"otp" + id}
											value={otp[id]}
											min={0}
											max={9}
											key={id}
											autoComplete="false"
											placeholder="0"
											onKeyUp={(e) => {
												if (
													e.target.value.length === 1
												) {
													if (
														e.target.value >= 0 &&
														e.target.value <= 9
													) {
														if (
															e.target.name ===
															"otp5"
														) {
															e.target.blur();
														} else {
															document
																.getElementsByName(
																	"otp" +
																		(+e
																			.target
																			.name[
																			e
																				.target
																				.name
																				.length -
																				1
																		] +
																			1)
																)[0]
																.focus();
														}
													} else {
														e.target.value = "";
													}
												}
											}}
											onChange={(e) => {
												setOtp((p) => {
													let toSet = [...p];
													let v = e.target.value;
													if (
														v.length === 0 ||
														(v.length === 1 &&
															+v[0] >= 0 &&
															+v[0] <= 9)
													)
														toSet[id] =
															e.target.value;
													return toSet;
												});
											}}
										/>
									))}
								</div>
								<Button
									type="submit"
									text="Verify OTP"
									size="small"
								/>
							</form>
						)}
					</div>
					{isOtpValid && (
						<img
							src={arrow}
							alt="Arrow"
							style={{
								position: "absolute",
								bottom: 0,
								right: "7.5rem",
								width: "10rem",
								height: "10rem",
							}}
						/>
					)}
				</section>
			)}
			{activeSection === 2 && (
				<section
					className="apply-2"
					style={{
						backgroundColor: "var(--grey)",
						color: "var(--white)",
					}}
				>
					<div className="apply-head" data-aos="fade-left">
						<h1>
							<ol start="2">
								<li>Enter Your Name</li>
							</ol>
						</h1>
					</div>
					<div className="apply-body" data-aos="fade-left">
						<div className="apply-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									name="name"
									value={applyData.name}
									onChange={handleChange}
									placeholder="Your Full Name"
								/>
							</form>
						</div>
					</div>
				</section>
			)}
			{activeSection === 3 && (
				<section
					className="apply-3"
					style={{
						backgroundColor: "var(--mac-tcolor)",
						color: "var(--white)",
					}}
				>
					<div className="apply-head" data-aos="fade-left">
						<h1>
							<ol start="3">
								<li>Phone No. (WhatsApp)</li>
							</ol>
						</h1>
					</div>
					<div className="apply-body" data-aos="fade-left">
						<div className="apply-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									name="phone"
									value={applyData.phone}
									onChange={handleChange}
									placeholder="Phone No."
									type="phone"
								/>
							</form>
						</div>
					</div>
				</section>
			)}
			{activeSection === 4 && (
				<section
					className="apply-4"
					style={{
						backgroundColor: "var(--light-green)",
						color: "var(--white)",
					}}
				>
					<div className="apply-head" data-aos="fade-left">
						<h1>
							<ol start="4">
								<li>Resume (Drive Link)</li>
							</ol>
						</h1>
					</div>
					<div className="apply-body" data-aos="fade-left">
						<div className="apply-body-top">
							<form onSubmit={handlePartialSubmit}>
								<Input
									name="resume"
									value={applyData.resume}
									onChange={handleChange}
									placeholder="Resume Drive Link"
									style={{
										width: "100%",
										fontSize: "1.75rem",
									}}
								/>
							</form>
						</div>
					</div>
				</section>
			)}
			{activeSection === 5 && (
				<>
					<section
						className="apply-5"
						style={{
							backgroundColor: "var(--mac-bgcolor)",
							color: "var(--white)",
						}}
					>
						<div className="apply-head" data-aos="fade-left">
							<h1>
								<ol start="5">
									<li>Why do you want to join EPMOC?</li>
								</ol>
							</h1>
						</div>
						<div className="apply-body" data-aos="fade-left">
							<div className="apply-body-top">
								<form onSubmit={handlePartialSubmit}>
									<TextArea
										rows={5}
										name="purpose"
										value={applyData.purpose}
										onChange={handleChange}
										required
										placeholder="Why do you want to join EPMOC (min 50 words)"
									/>
								</form>
							</div>
						</div>
					</section>
					{isValidInput && (
						<div className="apply-right">
							<Button
								text="Submit Your Application"
								onClick={(e) => {
									e.preventDefault();
									handleSubmit();
								}}
								icon="save"
								size="small"
							/>
						</div>
					)}
				</>
			)}
			{activeSection === 6 && (
				<section
					className="apply-6 apply-success"
					style={{
						backgroundImage: `url(${blobsTexture})`,
					}}
				>
					<div className="apply-success-card" data-aos="zoom-in">
						<div className="apply-success-card-image">
							<img src={tick} alt="Successful" />
						</div>
						<h1>
							Your Applicaiton has been submitted successfully
						</h1>
						<p>You will hear from one of us in next 6 days.</p>
						<div
							className="apply-success-buttons"
							style={{
								margin: "1rem 0",
							}}
						>
							<Button
								text="Explore Our Events"
								link="/events"
								color="green"
								icon="north_east"
								size="small"
								variant="outline"
							/>
							<Button
								text="Contact Us"
								link="/contact"
								color="green"
								icon="call"
								size="small"
							/>
						</div>
					</div>
				</section>
			)}
		</main>
	);
};

export default Apply;
